export const emailTest = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// eslint-disable-next-line no-useless-escape
export const nameTest = /[!@#$%^&*(){}\\|\/\+=\;]+/;
export const customizeNameRegex = /[0-9]{16}\s[0-9]{10}/;